<div class="step-header-container">
    <div class="step-creation-header">
        <ul class="step-creation-tab-list">
            <li class="step-creation-tab-list-item">
                <span *ngIf="dataSourceType !== ''">
                    <a routerLinkActive="active-link" routerLink="source-info/{{dataSourceType}}"> 1. Define source info & config steps </a>
                </span>
                <span *ngIf="dataSourceType === ''">
                    <a routerLinkActive="active-link" routerLink="source-info"> 1. Define source info & config steps </a>
                </span>
            </li>
            <mat-icon>east</mat-icon>
            <!-- <li class="step-creation-tab-list-item">
                <a routerLinkActive="active-link" routerLink="variable-pool"> 2. Define variable pool </a>
            </li>
            <mat-icon>east</mat-icon> -->
            <li class="step-creation-tab-list-item">
                <a routerLinkActive="active-link" routerLink="steps-builder/{{dataSourceType}}"> 2. Define steps, config settings & auth settings </a>
            </li>
            <mat-icon>east</mat-icon>
            <li class="step-creation-tab-list-item">
                <a routerLinkActive="active-link" routerLink="steps-graph/{{dataSourceType}}"> 3. Define edges </a>
            </li>
            <mat-icon>east</mat-icon>
            <li class="step-creation-tab-list-item">
                <a routerLinkActive="active-link" routerLink="drawing-board/{{dataSourceType}}"> 4. Define tables & columns </a>
            </li>
            <mat-icon>east</mat-icon>
            <li class="step-creation-tab-list-item">
                <a routerLinkActive="active-link" routerLink="review-steps//{{dataSourceType}}"> 5. Config Review </a>
            </li>
        </ul>
    </div>
    <div class="step-config-title" (click)="builderHeaderClickHandler($event)" *ngIf="currentStage === 'steps-builder'">
        <div class="step-config-title-wrapper" [ngClass]="{'pushed': stepsBuilderHelperService.isInputElementListOpen === true}">
            <h5 class="mb-0">Define the steps for integration setup process</h5>
            <div class="d-flex flex-gap-half ml-auto" *ngIf="stepsBuilderHelperService.isStepsLoaded === true">
                <div [matTooltip]="currentStep?.nodeType === 'FIRST_STEP_NODE' ? 'Cannot delete the first step': 'Delete step'">
                    <button *ngIf="currentStage === 'steps-builder'" 
                    [disabled]="(currentStep?.nodeType === 'FIRST_STEP_NODE' || 
                    stepsBuilderHelperService.isStepBeingDeleted === true || 
                    stepsBuilderHelperService.isStepBeingCreated === true || 
                    stepsBuilderHelperService.isStepBeingSaved === true) ? true : null"  (click)="deleteStep()" class="btn btn-primary btn-stroked" mat-button color="warn">
                        <mat-icon  class="" *ngIf="!stepsBuilderHelperService.isStepBeingDeleted">delete</mat-icon>
                        <mat-icon *ngIf="stepsBuilderHelperService.isStepBeingDeleted === true">
                            <mat-spinner color="primary" diameter="16">
                            </mat-spinner>
                        </mat-icon>
                        {{stepsBuilderHelperService.isStepBeingDeleted ? 'Deleting': 'Delete step'}}
                    </button>
                </div>
                <button mat-stroked-button color="primary" (click)="createNewStep()" class="d-flex add-step"
                [disabled]="(stepsBuilderHelperService.isStepBeingDeleted === true || 
                stepsBuilderHelperService.isStepBeingCreated === true ||
                stepsBuilderHelperService.isStepBeingSaved === true)">
                    <mat-icon *ngIf="!stepsBuilderHelperService.isStepBeingCreated">add</mat-icon>
                    <mat-icon *ngIf="stepsBuilderHelperService.isStepBeingCreated === true"><mat-spinner color="primary" diameter="16">
                    </mat-spinner></mat-icon>
                    Add Step
                </button>
                <button *ngIf="currentStage === 'steps-builder'" 
                [disabled]="(stepsBuilderHelperService.isStepBeingSaved === true ||
                stepsBuilderHelperService.isStepBeingCreated === true || 
                stepsBuilderHelperService.isStepBeingDeleted === true || stepsBuilderHelperService.isStepSaved === true) ? true : null"
                (click)="emitSaveEvent('save-step')" class="btn btn-primary btn-stroked" mat-flat-button color="primary">
                    <mat-icon  class="" *ngIf="!stepsBuilderHelperService.isStepBeingSaved">save</mat-icon>
                    <mat-icon *ngIf="stepsBuilderHelperService.isStepBeingSaved === true">
                        <mat-spinner color="primary" diameter="16">
                        </mat-spinner>
                    </mat-icon>
                    {{stepsBuilderHelperService.isStepBeingSaved  === true ? 'Saving' : 'Save step'}}
                </button>
            </div>
        </div>
    </div>
</div>